import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { reduxForm, getFormValues, getFormSyncErrors } from "redux-form";
import userContext from "../../userContext";
import { SUBMISSION_FORM_NAME } from "../contact.constants";
import ContactForm from "./ContactForm";
import controls from "../../controls";
import utilities from "../../utilities";

const {
  validations: {
    validateRequired,
    validateEmail,
    validatePassword,
    validateOptionalPhone,
    validateMustHaveTel1OrTel2
  }
} = controls;

const {
  transform: { sanitizeValue }
} = utilities;

const {
  actions: { patchUser: patchUserCreator },
  selectors: { getUserContext, getRedirect },
  actions: { logout: logoutCreator }
} = userContext;

class ContactFormContainer extends Component {
  componentDidUpdate() {
    const { initialValues, touch } = this.props;
    touch(...Object.keys(initialValues));
  }

  handleBlur = e => {
    const {
      initialValues,
      formSyncErrors,
      patchUser,
      initialize,
      formValues
    } = this.props;

    if (!e.target.value && !initialValues[e.target.name]) {
      return;
    }

    if (e.target.value === initialValues[e.target.name]) {
      return;
    }

    // We are updating fields on blur. With invalid values.
    /* if (
      formSyncErrors &&
      (formSyncErrors[e.target.name] !== undefined ||
        formSyncErrors.Email !== undefined)
    ) {
      return;
    } */

    initialize(formValues);

    patchUser({
      [e.target.name]: sanitizeValue(e.target.value)
    });
  };

  render() {
    return (
      <ContactForm
        onBlur={this.handleBlur}
        emailValidations={[validateRequired, validateEmail]}
        passwordValidations={[validateRequired, validatePassword]}
        officePhoneValidations={[
          validateMustHaveTel1OrTel2,
          validateOptionalPhone
        ]}
        cellPhoneValidations={[
          validateMustHaveTel1OrTel2,
          validateOptionalPhone
        ]}
      />
    );
  }
}

ContactFormContainer.propTypes = {
  patchUser: PropTypes.func.isRequired,
  formSyncErrors: PropTypes.object
};

const mapStateToProps = state => ({
  formValues: getFormValues(SUBMISSION_FORM_NAME)(state),
  formSyncErrors: getFormSyncErrors(SUBMISSION_FORM_NAME)(state),
  initialValues: getUserContext(state),
  redirect: getRedirect(state)
});

const mapDispatchToProps = dispatch => ({
  patchUser: payload => dispatch(patchUserCreator(payload)),
  logout: () => dispatch(logoutCreator())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: SUBMISSION_FORM_NAME,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    destroyOnUnmount: false
  })(ContactFormContainer)
);
